import { Component } from '@angular/core';
import { DigitaleLernformService } from '../../../../services/facetten/instance/lernformen-facetten/digitalelernform.service';
import { LernformFacettenService } from '../../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { UnterrichtsformBasisFacetteComponent } from '../unterrichtsform-basis-facette/unterrichtsform-basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-digitale-lernform-facette',
  templateUrl: './digitale-lernform-facette.component.html',
  imports: [UnterrichtsformBasisFacetteComponent],
  providers: [
    // Hier wird der LernformFacettenService injected, welcher dann in der UnterrichtsFormBasisFacette verwendet werden kann
    { provide: LernformFacettenService, useExisting: DigitaleLernformService }
  ]
})
export class DigitaleLernformFacetteComponent {}
